
<template>
    <div class="page-header-style">
        <ul class="nav nav-pills">
            <li class="disabled"><h4 style="margin-left:15px; margin:10px" class="text-primary"><b>{{carehomeName}} {{çarehomeId}}</b></h4></li>
            <!--<li class="pull-right">
                <router-link :to="{ name: 'patient-create', params: { carehomeid: carehomeId}}">
                    Add Patient
                </router-link>
            </li>-->
            <li class="pull-right">
                <router-link :to="{ name: 'charts', params: { carehomeid: carehomeId }}">
                    Print Charts
                </router-link>
            </li>
            <li class="pull-right">
                <router-link :to="{ name: 'carehome-dispensation', params: { carehomeid: carehomeId}}">
                    MAR Status
                </router-link>
            </li>
        </ul>
        <!--<hr style="margin-top:0px" />-->
    </div>
</template>
<script>

    export default {
        props: ['carehomeId', 'carehomeName'],
        data: function () {
            return {}
        }
    }
</script>


// WEBPACK FOOTER //
// CarehomeHeader.scp.html?41f6ddfe